import React from 'react';
import PropTypes from 'prop-types';
import {Button} from '@learningblocks/shared-components';
import style from './style.module.scss';

const ENTER_KEY = 13;

/**
 * CompleteButton:
 *  - Button clicked to end simulation [ displayed in EndSimulationBanner ]
 */
export function CompleteButton(props) {
  const className = `${style.btn} ${props.className}`;

  const onClick = (event) => {
    event.preventDefault();
    props.onClick();
  };

  const onKeyDown = (event) => event.keyCode === ENTER_KEY && props.onClick();

  return (
    <Button
      type='secondary'
      onKeyDown={onKeyDown}
      onClick={onClick}
      className={className}
      tabIndex={props.tabIndex}>
      Complete
    </Button>
  );
}

CompleteButton.propTypes = {
  /**
   * ClassName
   */
  className: PropTypes.string,
  /**
   * Callback for Button click
   */
  onClick: PropTypes.func,
  /**
   * tabIndex to set on button
   */
  tabIndex: PropTypes.number,
};

CompleteButton.defaultProps = {
  className: '',
};
